// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3nJEN","info":"UpdateTermsInfo_info__nIzgQ"};